import { create } from 'zustand';

import { User } from 'api/profile/type';

interface UpdateMyProfileModalState {
  isOpen: boolean;
  onUpdateMyProfileModalClose: () => void;
  onUpdateMyProfileModalOpen: (userData: User) => void;
  userData: User;
  isCustomer: boolean;
  setUserData: (userData: User) => void;
}

export const useUpdateMyProfileModalStore = create<UpdateMyProfileModalState>(set => ({
  isOpen: false,
  userData: {} as User,
  isCustomer: false,
  onUpdateMyProfileModalClose: () => set({ isOpen: false }),
  onUpdateMyProfileModalOpen: (userData: User) =>
    set({
      isOpen: true,
      userData,
      isCustomer: userData.role === 'pest_client',
    }),
  setUserData: (userData: User) =>
    set({
      userData,
      isCustomer: userData.role === 'pest_client',
    }),
}));
